import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import { Box as Base } from "@chakra-ui/core";
import { jsx as ___EmotionJSX } from "@emotion/react";
var Card = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return ___EmotionJSX(Base, _extends({
    bg: "white",
    borderRadius: "md",
    shadow: "md",
    ref: ref
  }, props));
});
export default Card;